import { render } from "./OverviewView.vue?vue&type=template&id=32b1402e&scoped=true"
import script from "./OverviewView.vue?vue&type=script&lang=js"
export * from "./OverviewView.vue?vue&type=script&lang=js"

import "./OverviewView.vue?vue&type=style&index=0&id=32b1402e&scoped=true&lang=css"

import exportComponent from "/Users/anja/Documents/GitHub/masterthesis/vue-js/monstradore/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32b1402e"]])

export default __exports__